import { FC } from 'react';
import cn from 'classnames';
import { Tooltip as TooltipCustom } from 'components/common';
import { TooltipPropsType } from '../Tooltip/Tooltip';
import { IconQuestion } from 'shared/ui';

import styles from './Hint.module.scss';

interface HintProps {
	title: string;
	label?: string;
	className?: string;
	placement?: TooltipPropsType['placement'];
}
const Hint: FC<HintProps> = ({ label, title, className, placement = 'bottom' }) => (
	<TooltipCustom background="dark" title={title} placement={placement} followCursor={false}>
		<div className={cn(styles.question__wrapper, className)}>
			<IconQuestion />
			{label && <div className={styles.question__title}>{label}</div>}
		</div>
	</TooltipCustom>
);

export default Hint;
